var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApplePayCardSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 16,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 15,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  rx: 2.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 15,
  x: 0.5,
  y: 0.5,
  stroke: "#000",
  rx: 2.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.774 5.818c.18-.223.302-.523.27-.829a1.17 1.17 0 0 0-.77.396c-.168.19-.316.503-.277.796.295.026.59-.146.777-.363M6.04 6.238c-.429-.025-.794.242-.999.242s-.518-.229-.858-.223a1.27 1.27 0 0 0-1.076.648c-.46.789-.121 1.958.327 2.6.218.317.48.667.826.654.327-.013.455-.21.852-.21s.512.21.858.204c.358-.007.583-.318.8-.636.25-.362.352-.711.359-.73-.007-.007-.692-.268-.698-1.05-.007-.654.538-.965.563-.984-.307-.451-.787-.502-.954-.515M9.776 5.353c.933 0 1.582.637 1.582 1.566 0 .931-.662 1.572-1.605 1.572H8.72v1.629h-.746V5.353zM8.72 7.87h.856c.65 0 1.02-.347 1.02-.948s-.37-.945-1.016-.945h-.86zM11.553 9.132c0-.608.47-.981 1.303-1.028l.96-.056v-.267c0-.387-.264-.618-.704-.618-.416 0-.676.198-.74.509h-.679c.04-.628.58-1.09 1.446-1.09.85 0 1.392.446 1.392 1.143v2.395h-.69v-.572h-.016c-.203.387-.646.631-1.106.631-.686 0-1.166-.423-1.166-1.047m2.262-.314v-.274l-.863.053c-.43.03-.672.218-.672.515 0 .304.253.502.64.502.502 0 .895-.343.895-.796M15.182 11.398v-.578c.053.013.173.013.233.013.333 0 .513-.139.623-.495 0-.007.063-.212.063-.215l-1.265-3.479h.78l.885 2.828h.013l.887-2.828h.759l-1.312 3.657c-.3.843-.647 1.114-1.373 1.114a3 3 0 0 1-.293-.017"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgApplePayCardSmall);
export default ForwardRef;